import Vue from "vue";
import VueRouter from "vue-router";

import Templates from "../components/templates.vue";
import Editor from "../components/editor.vue";
import Dashboard from "../components/dashboard.vue";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		redirect: "/dashboard"
	},
	{
		name: "templates",
		path: "/templates",
		component: Templates,
		meta: {
			load_notification_data: true
		},
		children: [
			{
				name: "edit",
				path: "edit/:notification_id",
				component: Editor,
				meta: {
					load_notification_data: true,
					hide_header: true,
					analytics: {
						pageviewTemplate() {
							return {
								page: "/app/templates/edit",
								title: document.title,
								location: window.location.href
							};
						}
					}
				}
			}
		]
	},
	{
		name: "dashboard",
		path: "/dashboard",
		component: Dashboard,
		meta: {
			load_notification_data: true,
			subscribe_to_notification_updates: true
		}
	},
	{
		path: "*",
		redirect: "/dashboard"
	}
];

const router = new VueRouter({
	mode: "history",
	base: "/app/",
	routes
});

export default router;
